module.exports = __webpack_public_path__ + "static/media/bank-gsb.5909e53f.png";